"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.URL_RATES_FINANCE = exports.URL_DUCKWORTH_CURRENCIES_CONFIG = void 0;
const URL_DUCKWORTH_CURRENCIES_CONFIG = exports.URL_DUCKWORTH_CURRENCIES_CONFIG = "https://duckworth.finance-prod.skypicker.com/currencies-config";
const URL_RATES_FINANCE = exports.URL_RATES_FINANCE = "https://rates-finance.skypicker.com/";